module.exports = __webpack_public_path__ + "static/media/trash.3211b93a.svg";